import hooks from './contact.hooks';
import createSchema from './contact.schema';

export default (app) => {
  const service = app.service('api/contact');
  service.schema = createSchema(app);
  service.hooks(hooks);
};
